import Logger from './logger.esm.js';

var logger = new Logger();

export { logger as default };
